<div class="c-form__selectbox c-form__small">
  <select class="c-form__select" [(ngModel)]="value">
    <option *ngIf="emptyOption" value="">
      {{ emptyOptionLabel }}
    </option>
    <option *ngFor="let option of options" [value]="option.value">
      {{ option.label }}
    </option>
  </select>
</div>